import { PageHeader } from '@organisms';
import { Space } from 'antd';
import { FC } from 'react';

import {
  MarketplaceStepper,
  MarketplaceStepperProps,
} from './MarketplaceStepper';

interface MarketplaceStepHeaderProps extends MarketplaceStepperProps {
  title: string;
  subtitle: string;
  backToPath: string | (() => void);
}

export const MarketplaceStepHeader: FC<MarketplaceStepHeaderProps> = ({
  currentStep,
  onChangeStep,
  stepsCompleted,
  stepsWithErrors,
  title,
  subtitle,
  backToPath,
}) => {
  return (
    <Space direction='vertical' size={'large'} style={{ width: '100%' }}>
      <PageHeader
        backToPath={backToPath}
        title={title}
        subTitle={subtitle}
        hasDivider={false}
      />

      <MarketplaceStepper
        currentStep={currentStep}
        onChangeStep={onChangeStep}
        stepsCompleted={stepsCompleted}
        stepsWithErrors={stepsWithErrors}
      />
    </Space>
  );
};
